export enum EChartAxisTypes {
    CATEGORY = 'category',
    VALUE = 'value',
    TIME = 'time',
    LOG = 'log'
}
